import React from 'react';
import { Chip } from '@mui/material';

const ComingSoonBadge = () => (
  <Chip
    label='Coming soon'
    size='small'
    sx={{
      height: 22,
      fontSize: 11,
      fontWeight: 600,
      bgcolor: '#f3e8ff',
      color: '#7e22ce',
      '& .MuiChip-label': { px: 1 },
    }}
  />
);

export default ComingSoonBadge;
